import React from "react";
import { connect } from "react-redux";
import classNames from 'classnames';
import { Link } from "@quintype/components";
import get from "lodash/get";

function getInlineStyle(inlineStyle, sectionColor) {
  if(inlineStyle) {
    if(sectionColor && (!inlineStyle.border && !inlineStyle.borderBottom)) {
      return Object.assign({}, inlineStyle, { borderBottom: `solid 2px ${sectionColor}` });
    } 
  } else if(sectionColor) {
    return { borderBottom: `solid 2px ${sectionColor}` };
  }
  return inlineStyle;
}


function SectionNameBase(props) {
  const sectionColor = props.sectionToColor(props.section);

  const inlineStyle = getInlineStyle(props.inlineStyle, sectionColor);
  
  if(props.hideLink) {
    return <section data-section-name="true" className = "section"><div className={classNames("section-name", "qt-theme__color--border", {"section-name--large": props.type === 'large'})} style={inlineStyle}>
      {props.name}
    </div></section>
  }

  const sectionLink = get(props.section, ['slug'], "#");
  return (
    <div >
    <Link href={`/${sectionLink}`} className={classNames("section-name", "qt-theme__color--border", {"section-name--large": props.type === 'large'})} style={inlineStyle}>
      {props.name}
    </Link>
  </div>
  );
}

function mapStateToProps(state) {
  return {
    sectionToColor(section) {
      const defaultColor = get(state.qt.config, ["theme-attributes", "primary_color"], "#000000");
      if(section) {
        const menuItem = state.qt.config.layout.menu.find(item => item.type == 'section' && section.id === item["item-id"]);
        return get(menuItem, ["data", "color"], defaultColor);
      }
      return defaultColor;
    }
  }
}

export const SectionName = connect(mapStateToProps)(SectionNameBase);